import React, {Component} from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';
import { HashLink as Link } from 'react-router-hash-link';

import HeaderSocial from './HeaderSocial.js';
import HeaderAccess from './HeaderAccess.js';
import HeaderContact from './HeaderContact.js';
import LanguageSwitcher from './LanguageSwitcher.js';

//img
import menuImg from '../../assets/icons/menu.svg';
import chevronDown from '../../assets/icons/chevron-down.svg';
import chevronDownContrast from '../../assets/icons/chevron-down-contrast.svg';
import chevronUp from '../../assets/icons/chevron-up.svg';
import chevronUpContrast from '../../assets/icons/chevron-up-contrast.svg';

class HeaderMobileMenu extends Component {
    constructor() {
        super();
        this.state = {};
    };

    toggleChildren = (id) => {
        this.setState({isOpened: this.state.isOpened === id ? '' : id});
    };

    render () {
        const { clang, data, cfont, setFontSize, contrast, setContrast, setOpened, openedElem, setLang, availableLanguages, toggleMobileMenu } = this.props;
        const { isOpened } = this.state;

        return (
            <ul className="header__nav--mobile">
                <li className="header__mobile__menu-header">
                    <div className="header__mobile__header">
                        <img src={menuImg} className="header__mobile-trigger__img" alt="" />
                        {lang[clang].main_page.menu}
                    </div>
                    <button className="header__mobile__close" onClick={() => toggleMobileMenu()}>
                    </button>
                </li>
                <li className="header__mobile__menu-actions">
                    <HeaderAccess
                        setFontSize={setFontSize}
                        setOpened={setOpened}
                        openedElem={openedElem}
                        cfont={cfont}
                        setContrast={setContrast}
                        contrast={contrast}/>
                    <LanguageSwitcher
                        type="lang"
                        setLang={setLang}
                        setOpened={setOpened}
                        openedElem={openedElem}
                        availableLanguages={availableLanguages}/>
                    <HeaderContact />
                    <HeaderSocial />
                </li>
                <div className="header__nav--mobile__items">
                    <li className="header__nav--mobile__item active">
                        <Link to={`/`} className="header__nav--mobile__item__link" title={lang[clang].home}>
                            {lang[clang].home}
                        </Link>
                    </li>
                    {data.map(menuItem =>
                        <li key={menuItem.id} className="header__nav--mobile__item">
                            <div className="header__nav--mobile__item-container">
                                <Link to={`${menuItem.url}`} className="header__nav--mobile__item__link" title={menuItem.title}>
                                    {menuItem.title}
                                </Link>
                                {menuItem.children &&
                                    <button onClick={() => this.toggleChildren(menuItem.id)}>
                                        {isOpened !== menuItem.id && <img src={chevronDown} alt="" className="header__nav--mobile__item-open"/>}
                                        {isOpened !== menuItem.id && <img src={chevronDownContrast} alt="" className="header__nav--mobile__item-open contrast"/>}
                                        {isOpened === menuItem.id && <img src={chevronUp} alt="" className="header__nav--mobile__item-open"/>}
                                        {isOpened === menuItem.id && <img src={chevronUpContrast} alt="" className="header__nav--mobile__item-open contrast"/>}
                                    </button>}
                            </div>
                            {menuItem.children && isOpened === menuItem.id &&
                                <div className="header__nav--mobile__dropdown">
                                    <ul className="header__nav--mobile__dropdown-list">
                                        {menuItem.children.map(child =>
                                            <li key={child.id} className="header__nav--mobile__dropdown-list-item">
                                                <Link
                                                to={`${child.url}`}
                                                className="header__nav--mobile__dropdown-link"
                                                title={child.title}
                                                scroll={el => el.scrollIntoView({ block: 'start' })}>
                                                {/* <Link to={`${child.url}`} className="header__nav--mobile__dropdown-link active" title={child.title}> */}
                                                    {child.title}
                                                </Link>
                                            </li>)}
                                    </ul>
                                </div>}
                          </li>)}
                </div>
            </ul>
        );
    };
};


HeaderMobileMenu.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(HeaderMobileMenu);



// WEBPACK FOOTER //
// ./src/components/header/HeaderMobileMenu.js